<template>
  <spinner />
</template>

<script>
import { mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'
import { APPLICATION_DELETE, FETCH_PROFILE } from '@/store/actions.type'
import { buildOauthState } from '@/common/oauth-state'

export default {
  name: 'MercadolibreV2IntegrationPage',
  components: {
    Spinner
  },
  data() {
    return {
      platformSlug: 'meli-v2',
      integrationDone: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'ongoing'
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
    user: {
      handler(val) {
        if (!val || !val.id || this.integrationDone) return
        this.integrationDone = true
        if (this.$route.query.code) this.setMeliV2Integration()
        else this.startAuthorization()
      },
      immediate: true
    }
  },
  beforeMount() {
    this.$store.dispatch(FETCH_PROFILE)
  },
  methods: {
    meliCountry() {
      const isoCode = (this.user && this.user.company && this.user.company.country_iso_code) || window.country
      return (window.countries || []).find(x => x.iso_code && isoCode &&
        String(x.iso_code).toUpperCase() === String(isoCode).toUpperCase()) || null
    },
    meliAuthDomain() {
      const country = this.meliCountry()
      const domain = country && country.front_config && country.front_config.domain
      return domain || '.com.ar'
    },
    startAuthorization() {
      const meli = this.$appConfig.integrations[this.platformSlug]
      const state = buildOauthState(this.platformSlug, window.location.hostname)
      const query = [
        'response_type=code',
        `client_id=${meli.appId}`,
        `state=${encodeURIComponent(state)}`
      ].join('&')
      window.location.href = `https://auth.mercadolibre${this.meliAuthDomain()}/authorization?${query}`
    },
    async generateApplication() {
      const { data: response } = await this.$http.get(this.$appConfig.api.baseUrl + 'platforms')
      const thePlatform = response.data.find(x => x.slug === this.platformSlug)
      if (!thePlatform) throw new Error("platform '" + this.platformSlug + "' not found")
      const application = this.getPreviousApplication(thePlatform)
      if (application) return { application, created: false }
      const payload = {
        name: this.user.company.name + ' ' + thePlatform.name,
        company_id: this.user.company_id,
        platform_id: thePlatform.id,
        active: true
      }
      const { data } = await this.$http.post(this.$appConfig.api.baseUrl + 'applications', payload)
      return { application: data, created: true }
    },
    getPreviousApplication(thePlatform) {
      const applications = (this.$store.getters.profile.company || {}).applications || []
      const mine = applications.filter(x => x.platform && x.platform.id === thePlatform.id && x.id && x.key)
      return mine.find(x => !x.webhook_url) || null
    },
    async setMeliV2Integration() {
      if (!this.user || !this.user.company_id) return this.throwNoCompany()
      let orphan = null
      try {
        const { application: credentials, created } = await this.generateApplication()
        if (created) orphan = credentials
        const meli = this.$appConfig.integrations[this.platformSlug]
        const body = {
          code: String(this.$route.query.code),
          companyId: String(this.user.company_id),
          appId: credentials.id,
          appKey: credentials.key,
          platformId: this.meliV2PlatformId(),
          ecosystemId: (this.siteName || '').toLowerCase(),
          userId: String(this.user.id)
        }
        await this.$http.post(meli.baseUrl + 'v2/meli/auth/install', body, { headers: { 'x-api-key': meli.header } })
        orphan = null
        this.$store.dispatch(FETCH_PROFILE).then(() => {
          this.$store.commit('setProfile', { profile: this.user })
          this.$router.push({ name: 'mercadolibre-v2' })
        })
      } catch (error) {
        await this.discardApplication(orphan)
        const message = error && error.body && error.body.message
          ? error.body.message
          : this.$gettext('There were errors while integrating.')
        this.$router.push({ name: 'company-integrations', query: { error: message } })
      }
    },
    async discardApplication(application) {
      if (!application || !application.id) return
      try {
        await this.$store.dispatch(APPLICATION_DELETE, application.id)
      } catch (e) {
        console.log('No se pudo borrar la application huérfana', application.id, e)
      }
    },
    throwNoCompany() {
      const obj = {
        title: 'ERROR',
        message: this.$gettextInterpolate(this.$gettext('Your user doesn\'t have a company defined which is required to be able to enjoy the benefits of the e-commerce integrations.<br><br>Please write to <a href="mailto:%{helpEmail}">%{helpEmail}</a> to get this solved.'), { helpEmail: this.helpEmail }),
        type: 'error'
      }
      this.$root.$children[0].$refs.simplert.openSimplert(obj)
      this.$router.push({ name: 'search' })
    }
  }
}
</script>
